export default {
  COLOR: {
    LIGHT_BLUE: 'info', // 淡藍色
    RED: 'danger', // 紅色
    YELLOW: 'warning', // 黃色
    BLACK: 'dark', // 黑色
  },
};
